import { Component } from '@angular/core';

@Component({
  selector: 'app-registration-layout',
  standalone: false,
  templateUrl: './registration-layout.component.html',
  styleUrl: './registration-layout.component.scss'
})
export class RegistrationLayoutComponent {

}
